import React, { useEffect, useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
const TESTIMONIALS = [{
  name: 'Sarah M.',
  location: 'Texas',
  title: 'Finally — I know exactly why things go wrong and how to fix them',
  body: 'I spent months watching YouTube and every time my resin came out sticky or covered in bubbles. I honestly thought I was just bad at this. This program explained WHY for the first time. I made my first clean piece on Day 4. I listed it on Etsy the same week.',
  avatarLabel: 'PHOTO — Sarah M., Texas',
  initials: 'SM'
}, {
  name: 'Jennifer L.',
  location: 'Ontario, Canada',
  title: 'The pre-pour checklist alone was worth every penny',
  body: "I'd already bought two other courses and both were just project tutorials. Nothing about what to actually do when something goes wrong. The error correction guide in this program is something I've never seen anywhere else. Haven't had a ruined piece since.",
  avatarLabel: 'PHOTO — Jennifer L., Ontario',
  initials: 'JL'
}, {
  name: 'Michelle R.',
  location: 'Melbourne, Australia',
  title: "Not inspiration — actual structure. That's what I needed.",
  body: "I kept buying more pigments thinking the problem was my supplies. It wasn't. I had no system. Seven days later I had 3 pieces I was proud to photograph. I'm not artistic. I just follow the steps. And it works every single time.",
  avatarLabel: 'PHOTO — Michelle R., Melbourne',
  initials: 'MR'
}, {
  name: 'Rachel P.',
  location: 'Seattle, WA',
  title: 'I was ready to quit. This program saved my hobby.',
  body: "After three batches of sticky, bubbly pieces I was done. I'd spent over $200 on supplies with nothing to show. By Day 3 I understood what I'd been doing wrong all along. I feel like a completely different person at my workbench now.",
  avatarLabel: 'PHOTO — Rachel P., Seattle',
  initials: 'RP'
}];
const DM_SCREENSHOTS = [{
  imageUrl: 'https://cdn.magicpatterns.com/uploads/wLKKmfmnevsFthgqFi8PgN/1.webp',
  alt: 'DM screenshot from Erica457 sharing her dandelion resin lamp results',
  name: 'Erica457'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/7B4j6UAJEbiSWDEBL88PkK/2.webp',
  alt: 'DM screenshot from Kate sharing her resin table repair results',
  name: 'Kate'
}, {
  imageUrl: 'https://cdn.magicpatterns.com/uploads/nXVczYVKdbi2VFJYePn7Q8/3.webp',
  alt: 'DM screenshot from Hilare567 sharing her first resin tray results',
  name: 'Hilare567'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(1);
  useEffect(() => {
    const handleResize = () => {
      setItemsToShow(window.innerWidth >= 768 ? 2 : 1);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const totalPages = Math.ceil(TESTIMONIALS.length / itemsToShow);
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % totalPages);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + totalPages) % totalPages);
  };
  const visibleTestimonials = TESTIMONIALS.slice(currentIndex * itemsToShow, currentIndex * itemsToShow + itemsToShow);
  return <section className="w-full px-4 md:px-8 max-w-6xl mx-auto flex flex-col items-center" data-id="element-311">
      <FadeIn className="text-center mb-16" data-id="element-312">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-313">
          Real Results
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream mb-6" data-id="element-314">
          What Students Are Saying After 7 Days
        </h2>
      </FadeIn>

      {/* DM Screenshot Testimonials */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 w-full mb-10" data-id="element-315">
        {DM_SCREENSHOTS.map((dm, index) => <FadeIn key={`dm-${index}`} delay={index * 100} direction="up" className="h-full" data-id="element-316">
            <div className="bg-darkCard border border-darkBorder rounded-2xl overflow-hidden h-full hover:border-amber/30 transition-colors duration-300" data-id="element-317">
              <img src={dm.imageUrl} alt={dm.alt} className="w-full h-auto object-contain" data-id="element-318" />
            </div>
          </FadeIn>)}
      </div>

      {/* Testimonials Carousel */}
      <FadeIn delay={200} className="w-full mb-16 relative" data-id="element-319">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 w-full" data-id="element-320">
          {visibleTestimonials.map((review, index) => <div key={`${currentIndex}-${index}`} className="bg-darkCard border border-darkBorder rounded-2xl p-8 h-full flex flex-col relative overflow-hidden group hover:border-amber/30 transition-colors duration-300 animate-fade-in-up" data-id="element-321">
              {/* Watermark */}
              <div className="absolute top-4 right-6 text-amber/5 text-8xl font-playfair leading-none select-none pointer-events-none group-hover:text-amber/10 transition-colors duration-300" data-id="element-322">
                "
              </div>

              <div className="flex gap-1 mb-6 relative z-10" data-id="element-323">
                {[...Array(5)].map((_, i) => <svg key={i} className="w-5 h-5 text-amber fill-current" viewBox="0 0 20 20" data-id="element-324">
                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-325" />
                  </svg>)}
              </div>

              <h3 className="font-playfair italic font-bold text-xl text-cream mb-4 relative z-10" data-id="element-326">
                "{review.title}"
              </h3>

              <p className="font-lato text-cream/70 leading-relaxed mb-8 flex-1 relative z-10" data-id="element-327">
                {review.body}
              </p>

              <div className="mt-auto pt-6 border-t border-darkBorder relative z-10 flex items-center gap-3" data-id="element-328">
                <div className="w-[52px] h-[52px] bg-darkCard border-2 border-amber rounded-full flex items-center justify-center flex-shrink-0" title={review.avatarLabel} data-id="element-329">
                  <span className="text-cream/40 font-lato text-sm font-bold" data-id="element-330">
                    {review.initials}
                  </span>
                </div>
                <div className="flex flex-col" data-id="element-331">
                  <span className="font-lato font-bold text-cream" data-id="element-332">
                    {review.name}
                  </span>
                  <span className="font-lato text-sm text-cream/50" data-id="element-333">
                    {review.location}
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Carousel Controls */}
        <div className="flex items-center justify-center gap-6 mt-8" data-id="element-334">
          <button onClick={prevSlide} className="w-10 h-10 rounded-full bg-darkCard border border-darkBorder flex items-center justify-center text-amber hover:bg-amber/10 hover:border-amber/50 transition-all" aria-label="Previous testimonials" data-id="element-335">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-336">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-337" />
            </svg>
          </button>

          <div className="flex gap-2" data-id="element-338">
            {[...Array(totalPages)].map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentIndex === i ? 'bg-amber w-6' : 'bg-darkBorder hover:bg-amber/50'}`} aria-label={`Go to slide ${i + 1}`} data-id="element-339" />)}
          </div>

          <button onClick={nextSlide} className="w-10 h-10 rounded-full bg-darkCard border border-darkBorder flex items-center justify-center text-amber hover:bg-amber/10 hover:border-amber/50 transition-all" aria-label="Next testimonials" data-id="element-340">
            <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-341">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-342" />
            </svg>
          </button>
        </div>
      </FadeIn>

      <FadeIn delay={300} className="w-full max-w-4xl" data-id="element-343">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 w-full" data-id="element-344">
          <div className="bg-darkCard border border-darkBorder rounded-xl p-4 md:p-5 text-center" data-id="element-345">
            <span className="text-[28px] mb-2 block" aria-hidden="true" data-id="element-346">
              ⭐
            </span>
            <span className="font-bold text-cream text-sm font-lato" data-id="element-347">
              4.9/5 Average Rating
            </span>
          </div>
          <div className="bg-darkCard border border-darkBorder rounded-xl p-4 md:p-5 text-center" data-id="element-348">
            <span className="text-[28px] mb-2 block" aria-hidden="true" data-id="element-349">
              ✅
            </span>
            <span className="font-bold text-cream text-sm font-lato" data-id="element-350">
              60-Day Guarantee
            </span>
          </div>
          <div className="bg-darkCard border border-darkBorder rounded-xl p-4 md:p-5 text-center" data-id="element-351">
            <span className="text-[28px] mb-2 block" aria-hidden="true" data-id="element-352">
              👩
            </span>
            <span className="font-bold text-cream text-sm font-lato" data-id="element-353">
              Designed for Beginners
            </span>
          </div>
          <div className="bg-darkCard border border-darkBorder rounded-xl p-4 md:p-5 text-center" data-id="element-354">
            <span className="text-[28px] mb-2 block" aria-hidden="true" data-id="element-355">
              🏠
            </span>
            <span className="font-bold text-cream text-sm font-lato" data-id="element-356">
              Works From Home
            </span>
          </div>
        </div>
      </FadeIn>
    </section>;
}